import moment from "moment";

const PROFESSIONAL_REGISTER_STEPS = {
  out_of_range: {
    step: 0,
    name: "Fora de cobertura",
    icon: "location_off",
    color: "gray",
    description:
      "Profissional se encontra fora da área de cobertura das cidades que atendemos."
  },
  created: {
    step: 1,
    name: "Cadastro criado",
    icon: "done",
    color: "blue",
    description: "A conta do profissional foi criada."
  },
  waiting_for_documents: {
    step: 2,
    name: "Aguardando envio dos documentos",
    icon: "fingerprint",
    color: "gray",
    description:
      "Esperando o envio dos documentos de identificação e selfie do profissional."
  },
  documents_validation_requested: {
    step: 2,
    name: "Requisitando a validação dos documentos",
    icon: "fingerprint",
    color: "blue",
    description:
      "Requisitando a validação dos documentos junto ao serviço responsável."
  },
  failed_documents_validation_request: {
    step: 2,
    name: "Erro ao requisitar validação dos documentos",
    icon: "fingerprint",
    color: "red",
    description: "Erro ao enviar os documentos de identificação para a análise."
  },
  waiting_documents_validation: {
    step: 2,
    name: "Documentos em análise",
    icon: "fingerprint",
    color: "blue",
    description: "Documentos de identificação em análise."
  },
  invalid_documents: {
    step: 2,
    name: "Documentos reprovados",
    icon: "fingerprint",
    color: "red",
    description: "Documentos de identificação reprovados."
  },
  valid_documents: {
    step: 2,
    name: "Documentos aprovados",
    icon: "fingerprint",
    color: "green",
    description: "Documentos de identificação aprovados."
  },
  background_check_requested: {
    step: 3,
    name: "Requisitando a verificação dos antecedentes do profissional",
    icon: "security",
    color: "grey",
    description:
      "Requisitando a validação dos antecedentes junto ao serviço responsável."
  },
  failed_background_check_request: {
    step: 3,
    name: "Erro ao requisitar a checagem dos antecedentes",
    icon: "security",
    color: "red",
    description:
      "Erro ao requisitar a verificação dos antecedentes do profissional."
  },
  waiting_background_check: {
    step: 3,
    name: "Verificando antecedentes",
    icon: "security",
    color: "blue",
    description: "Verificação dos antecedentes em análise."
  },
  background_check_success: {
    step: 3,
    name: "Antecedentes aprovados",
    icon: "security",
    color: "green",
    description: "Antecedentes aprovados."
  },
  background_check_failed: {
    step: 3,
    name: "Antecedentes reprovados",
    icon: "security",
    color: "red",
    description: "Antecedentes reprovados."
  },
  payment_account_requested: {
    step: 4,
    name: "Criando a PGA",
    icon: "account_balance_wallet",
    color: "grey",
    description:
      "A carteira do profissional está sendo criado junto ao nosso meio de pagamento."
  },
  payment_account_failed: {
    step: 4,
    name: "Erro ao criar PGA",
    icon: "account_balance_wallet",
    color: "red",
    description: "Ocorreu um erro ao criar a carteira do profissional."
  },
  payment_account_created: {
    step: 4,
    name: "PGA criada.",
    icon: "account_balance_wallet",
    color: "green",
    description: "Carteira do profissional criada com sucesso."
  },
  access_denied: {
    step: 9,
    name: "Acesso negado",
    icon: "block",
    color: "red",
    description: "Acesso negado."
  }
};

// Filters
const getStatusName = status => {
  return PROFESSIONAL_REGISTER_STEPS[status].name;
};

// methods
const getStatus = status => {
  return PROFESSIONAL_REGISTER_STEPS[status];
};

const eventName = event => {
  return event.split(".")[1].toLowerCase();
};

const isOutOfRange = status => {
  return ["out_of_range"].includes(status);
};

const isCreatedStep = status => {
  return ["created"].includes(status);
};

const isDocumentsValidationStep = status => {
  return [
    "waiting_for_documents",
    "documents_validation_requested",
    "failed_documents_validation_request",
    "waiting_documents_validation",
    "invalid_documents",
    "valid_documents"
  ].includes(status);
};

const isBackgroundcheckValidationStep = status => {
  return [
    "background_check_requested",
    "failed_background_check_request",
    "waiting_background_check",
    "background_check_success",
    "background_check_failed"
  ].includes(status);
};

const isPgaValidationStep = status => {
  return [
    "payment_account_requested",
    "payment_account_failed",
    "payment_account_created"
  ].includes(status);
};

const isAccessDeniedValidationStep = status => {
  return ["access_denied"].includes(status);
};

const buildEventsHistory = events => {
  const eventsGroupedByType = groupEvents(events);

  return arrayOfEvents(eventsGroupedByType);
};

/**
 * Group the events by type (PROFESSIONAL_REGISTER_STEPS[step] | created, ocr check, background check, pga, etc).
 */
function groupEvents(events) {
  return orderEvents(events).reduce((newEvents, event) => {
    const status = getStatus(eventName(event.event_type));
    const relatedEvents = Object.keys(newEvents).includes(
      status.step.toString()
    )
      ? newEvents[status.step]
      : {};

    newEvents = {
      ...newEvents,
      [status.step]: {
        events: [...(relatedEvents.events || []), event],
        lastOccurency:
          relatedEvents.lastOccurency &&
          moment(relatedEvents.lastOccurency) > moment(event.created_at)
            ? moment(relatedEvents.lastOccurency)
            : moment(event.created_at)
      }
    };

    return newEvents;
  }, []);
}

function orderEvents(events) {
  return events
    .map(event => {
      return {
        ...event,
        created_at: moment(event.created_at)
      };
    })
    .sort((a, b) => a.created_at.valueOf() - b.created_at.valueOf());
}

/**
 * Convert the events grouped by type in an array to improve its manupulation on render.
 */
function arrayOfEvents(events) {
  return Object.keys(events).map(step => {
    return {
      step: step,
      lastOccurency: events[step].lastOccurency,
      events: events[step].events
    };
  });
}

export default {
  filters: {
    getStatusName
  },

  methods: {
    getStatus,
    eventName,
    isOutOfRange,
    isCreatedStep,
    isDocumentsValidationStep,
    isBackgroundcheckValidationStep,
    isPgaValidationStep,
    isAccessDeniedValidationStep,
    buildEventsHistory
  }
};



// WEBPACK FOOTER //
// ./src/mixins/professionalRegisterFlowMixin.js